import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default {
  __name: 'BSkeleton',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    width: {
      type: String,
      default: '100%'
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["b-skeleton b-skeleton-animate-wave", {
          'b-skeleton-text': props.type === 'text',
          'b-skeleton-input': props.type === 'input',
          'b-skeleton-button': props.type === 'button',
          'b-skeleton-avatar': props.type === 'avatar'
        }]),
        style: _normalizeStyle({
          'width': __props.width
        })
      }, null, 6);
    };
  }
};